<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("menu.mlhg") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="md"
            type="neutral"
            @click="handleCreate()"
            v-if="isDtacAdmin || isCorporateAdmin || isCorporateSuperAdmin"
            >{{ $t("new") }}</base-button
          >
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">{{ corporate_name }} : {{ $t("menu.mlhg") }}</h3>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>

              <el-table-column
                min-width="180px"
                align="right"
                :label="$t('mlhg.pilot_number_type')"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
                  <template v-if="row.PilotType == 4">
                  {{ $t("mlhg.pilot_number_real") }}
                  </template>
                  <template v-else>
                  {{ $t("mlhg.pilot_number_dummy") }}
                  </template>
                </div>
              </el-table-column>

              <el-table-column
                min-width="180px"
                align="right"
                :label="$t('actions')"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
                  <router-link
                    :to="{
                      name: 'mlhg_number',
                      query: {
                        mlhg_id: row.ID,
                        mlhg_name: row.Name,
                        pilot_type: row.PilotType == 4 ? 'real': 'dummy',
                        corporate_name: $route.query.name,
                        corporate_id: $route.query.id
                      }
                    }"
                  >
                    <base-button class="edit" type="warning" size="sm" icon>
                      {{ $t("menu.number") }}
                    </base-button>
                  </router-link>


                   <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                    v-if="row.PilotType == 4 && (isDtacAdmin)"
                  >
                    <i class="text-dtac-bt fa fa-trash"></i>
                  </base-button>
                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                    v-if="row.PilotType != 4 && (isDtacAdmin || isCorporateSuperAdmin || isCorporateAdmin)"
                  >
                    <i class="text-dtac-bt fa fa-trash"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          :label="$t('group_name')"
          :placeholder="$t('group_name')"
          input-classes="form-control-alternative new-event--title"
          v-model="edit_name"
        >
        </base-input>

        <base-input :label="$t('mlhg.pilot_number_type')" v-if="isDtacAdmin">
          <el-select
            :placeholder="$t('mlhg.pilot_number_type')"
            v-model="pilot_type"
          >
            <el-option
              v-for="item in pilot_number_type"
              :key="item.ID"
              :label="item.Name"
              :value="item.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input :label="$t('mlhg.pilot_number_real')"
          v-if="pilot_type == 4 && (isDtacAdmin)"
        >
          <el-select
            :placeholder="$t('mlhg.pilot_number_real')"
            v-model="pilot_real"
          >
            <el-option
              v-for="item in getRealNumber"
              :key="item"
              :label="item.Number"
              :value="item"
            >
            </el-option>
          </el-select>
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-sm btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import Modal from "@/components/Modal";
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    Modal,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isCorporateSuperAdmin: "Auth/isCorporateSuperAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      tableData: "Mlhg/getData",
      pilotNumber: "PilotNumber/getData",
      getUser: "Auth/getUser"
    }), 
    getRealNumber:function(){
      let result =  this.pilotNumber.filter((m)=>{
          return m.EnterpriseID ==  this.corporateId && m.Type == "4"
        });
        return result
    },
    tableColumns: function() {
      return [
        {
          prop: "Name",
          label: this.$t("menu.mlhg"),
          minWidth: 160,
          sortable: true
        },
        {
          prop: "PilotNumber",
          label: this.$t("mlhg.pilot_number"),
          minWidth: 160,
          sortable: true
        }
      ];
    },
    corporate_name: function() {
      // return "corp"
      return this.isDtacAdmin || this.isReadOnly || this.isCorporateSuperAdmin
        ? this.$route.query.name
        : this.getUser.corporate_name;
    }
  },
  mounted() {
    this.listData({
      enterpriseID: this.isCorporateAdmin
        ? this.getUser.id
        : this.$route.query.id
    });
    this.listRealNumber({
      enterpriseID: this.isCorporateAdmin
        ? this.getUser.id
        : this.$route.query.id
    })
  },
  data() {
    return {
      showAddModal: false,
      propsToSearch: ["name", "email"],
      selectedRows: [],

      mode: "create",
      rowEdit: {},
      edit_name: "",
      corporate: "",
      pilot_type: 1,
      pilot_real : "",
      corporateId: this.isCorporateAdmin
        ? this.getUser.id
        : this.$route.query.id,
      pilot_number_type: [
        { ID: 1, Name: "Dummy Number" },
        { ID: 4, Name: "Real Number" }
      ],
    };
  },
  methods: {
    ...mapActions({
      createData: "Mlhg/createData",
      updateData: "Mlhg/updateData",
      deleteData: "Mlhg/deleteData",
      listData: "Mlhg/listData",
      listRealNumber: "PilotNumber/listDataByEnterprise",
    }),

    reloadMlhg() {
      this.listData({
        enterpriseID: this.isCorporateAdmin
          ? this.getUser.id
          : this.$route.query.id
      });
    },

    handleCreate() {
      this.mode = "create";
      this.showAddModal = true;
      this.edit_name = "";
      this.corporate = "";
      this.pilot_type = 1;
      this.pilot_real  = "";
    },

    handleEdit(index, row) {
      this.mode = "edit";
      this.rowEdit = row;
      this.showAddModal = true;
      this.edit_name = this.rowEdit.Name;
    },
    handleUpdate() {
      this.showAddModal = false;
      if (this.mode == "create") {
        this.createData({
          name: this.edit_name,
          numberType: this.pilot_type,
          realNumber: this.pilot_real.Number,
          realNumberID: this.pilot_real.ID,
          enterpriseID: this.corporateId
        })
          .then(resp => {
            this.reloadMlhg();
            swal.fire({
              title: this.$t(this.mode) + this.$t(resp.data.Msg),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      } else {
        this.rowEdit.Name = this.edit_name;
        this.updateData({
          id: this.rowEdit.ID,
          name: this.rowEdit.Name
        })
          .then(resp => {
            this.reloadMlhg();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      }
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteData({
              mlhgID: row.ID
            })
              .then(resp => {
                this.reloadMlhg();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style scoped>
.btn {
  margin: 2px;
}
.no-border-card .card-footer {
  border-top: 0;
}
</style>
